import { earningsHeadlineLevels } from '../constants'

export const earningsBridgeColumnKeys = {
  netSales: 'netSales',
  refunds: 'refunds',
  cogs: 'cogs',
  logistics: 'logistics',
  customs: 'customs',
  margin: 'margin',
}

export const earningsBridgeDeductionKeys = [
  earningsBridgeColumnKeys.refunds,
  earningsBridgeColumnKeys.cogs,
  earningsBridgeColumnKeys.logistics,
  earningsBridgeColumnKeys.customs,
]

export const earningsBridgeColumnOrder = [
  earningsBridgeColumnKeys.netSales,
  ...earningsBridgeDeductionKeys,
  earningsBridgeColumnKeys.margin,
]

export const earningsBridgeActiveDeductionKeys = {
  [earningsHeadlineLevels.operating]: earningsBridgeDeductionKeys,
  [earningsHeadlineLevels.product]: [earningsBridgeColumnKeys.cogs],
}

export const earningsBridgeFullShare = 100

export const earningsBridgePlotHeight = 240

export const earningsBridgeColumnLabels = {
  [earningsBridgeColumnKeys.netSales]: 'Ventas netas',
  [earningsBridgeColumnKeys.refunds]: 'Reembolsos',
  [earningsBridgeColumnKeys.cogs]: 'COGS',
  [earningsBridgeColumnKeys.logistics]: 'Logística',
  [earningsBridgeColumnKeys.customs]: 'Aduanas',
}

export const earningsBridgeCopies = {
  [earningsHeadlineLevels.operating]: {
    subtitle: 'Cómo cada paso se lleva un trozo de tus ventas netas hasta tu margen operativo.',
    headline: 'De {{netSales}} en ventas netas, quedan {{margin}} de margen operativo ({{percentage}}).',
    marginLabel: 'Margen operativo',
    note: 'Logística agrupa el envío de salida, devoluciones y cambios (ver Logistics). El ajuste de cambios ya está dentro de las ventas netas.',
  },
  [earningsHeadlineLevels.product]: {
    subtitle: 'Cómo el coste de producto se lleva un trozo de tus ventas netas hasta tu margen.',
    headline: 'De {{netSales}} en ventas netas, quedan {{margin}} después del coste de producto ({{percentage}}).',
    marginLabel: 'Margen',
    note: 'Esta vista muestra solo el margen de producto (ventas netas − coste de producto). Las devoluciones, la logística y las aduanas forman parte del margen operativo, que necesita tus costes de logística y aduanas.',
  },
}
